import { VDivider } from 'vuetify/lib/components/VDivider';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.saldos),function(saldo,index){return [_c('px-entrega-produtos-compras-item-content-saldo-row',{key:("row-" + (saldo.id)),attrs:{"saldo":saldo,"compra-produto":_vm.compraProduto}}),(index !== _vm.saldos.length - 1)?_c(VDivider,{key:("div-" + (saldo.id))}):_vm._e()]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }